export default "__VITE_ASSET__DwHk$E8J__"